<template>
  <!-- Nothing here yet: what is missing, why it matters, and the way to add it -->
  <View direction="column" align="center" justify="center" class="placeholder" :class="variant">
    <View direction="column" class="copy">
      <Text :variant="variant === 'compact' ? 'label-medium' : 'h4'">{{ title }}</Text>
      <Text variant="body-medium" color="tertiary">{{ subtitle }}</Text>
    </View>
    <Button variant="secondary" size="medium" data-manage-action @click="$emit('buttonClicked')">
      <Icon name="plus" />
      {{ buttonText }}
    </Button>
  </View>
</template>

<script setup lang="ts">
import { Button, Icon, Text, View } from '@tallo/design-system';

/** `card` takes the rows' place in an empty card; `compact` sits under rows the card still has, as a quiet block */
withDefaults(defineProps<{ title: string; subtitle: string; buttonText: string; variant?: 'card' | 'compact' }>(), {
  variant: 'card',
});

defineEmits(['buttonClicked']);
</script>

<style scoped lang="scss">
// Gaps stay here rather than on the Views, so the compact variant can tighten them
.placeholder {
  gap: var(--t-spacing-lg);
  flex: 1;
  padding: var(--t-spacing-md) 0 var(--t-spacing-sm);
  text-align: center;
}

.copy {
  gap: var(--t-spacing-sm);
  max-width: 28rem;
}

// A block of its own under the rows, centred in whatever room a neighbour's height leaves the card
.compact {
  flex: initial;
  margin-block: auto;
  gap: var(--t-spacing-md);
  padding: var(--t-spacing-md);
  border-radius: var(--t-border-radius-sm);
  background: var(--t-color-neutral-50);

  .copy {
    gap: var(--t-spacing-xs);
  }
}
</style>
